import SmartVideo from "./SmartVideo";

export default function ExampleVideo({fade, video, header, content, flexDir}) {
  return (
    <div data-aos={fade} className="exampleVideo" style={{flexDirection:flexDir}}>
        <div className="exampleVideo_details">
            <h3>{header}</h3>
            <p>{content}</p>
        </div>
        <SmartVideo src={video}/>
    </div>
  )
}
